import React, { useEffect, useRef } from "react";
import { connect, ConnectedProps } from "react-redux";
// actions
import CoreAction from "core/actions/common/CoreAction";
// interfaces
import ILanguageVersionDetail from "cms/interfaces/ILanguageVersionDetail";
// enums
import { EView } from "cms/enums/EView";
import { EViewType } from "cms/enums/EViewType";
import { EContentType } from "cms/enums/EContentType";
import IClientLanguage from "core/interfaces/IClientLanguage";
import { Dispatch } from "@reduxjs/toolkit";
import IClientSiteSettingDetail from "cms/interfaces/IClientSiteSettingDetail";
import LanguageVersionSelector from "cms/utilities/LanguageVersionSelector";
import { TINNRLayout } from "../type";
import { Link } from "react-router-dom";
import ContentHeaderRow from "components/ContentHeaderRow";
import { EResourceType } from "cms/enums/EResourceType";
import RMDRImage from "components/RMDRImage";
import { FaYoutube } from "react-icons/fa";
import ContactUsServiceAction from "cms/actions/components/InnerLayouts/INNR003/ContactUsServiceAction"
import ContactForm from "components/ContactForm";


function mapStateToProps ( state: any ) {
    console.log("INNR003.mapStateToProps: ", state);

    const webApplicationLanguage:IClientLanguage   = state.CoreStore.language?.payload;
    const webApplicationLanguageCode:string        = webApplicationLanguage.code;
    const webApplicationLanguageISOCode:string     = state.CoreStore.languageCode?.payload;

    const siteSettingDetailPayload:IClientSiteSettingDetail = state.SiteSettingStore.details?.payload;

    return {

        webApplicationLanguage,
        webApplicationLanguageCode,
        webApplicationLanguageISOCode,

        siteSettingDetailPayload
    
    }
}

function mapDispatchToProps ( dispatch: Dispatch ) {
    console.log("INNR003.mapDispatchToProps");

    const coreAction = new CoreAction(dispatch);
    const contactUsServiceAction = new ContactUsServiceAction(dispatch);

    return {
        // others
        _showLoader: () => { 
            coreAction.showLoader() 
        },

        _hideLoader: () => { 
            coreAction.hideLoader() 
        },

        _clean: () => {

            contactUsServiceAction.postClean();

        }
    }
}

const connector = connect ( mapStateToProps, mapDispatchToProps );


/* types */
type PropsFromRedux = ConnectedProps<typeof connector>


/* component */
function INNR003Loader () {

    return (
        <></>
    )

}

function INNR003 ( props:TINNRLayout<PropsFromRedux> ) {
    console.log("INNR003.rendered: ", props);

    const languageVersion = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.contentDetailPayload?.languageVersions,
        filters: [
            { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.DEFAULT }
        ],
        type: "find"
    });

    const googleMaps = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.contentDetailPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "googleMaps" }
        ],
        type: "find"
    });

    const letUsKnowAboutYourNextProject = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.contentDetailPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "letUsKnowAboutYourNextProject" }
        ],
        type: "find"
    });

    const addressString = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.contentDetailPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "addressString" }
        ],
        type: "find"
    });

    const address = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.contentDetailPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "address" }
        ],
        type: "find"
    });

    const phoneNumberString = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.contentDetailPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "phoneNumberString" }
        ],
        type: "find"
    });

    const phone01 = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.contentDetailPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "phone01" }
        ],
        type: "find"
    });

    const phone02 = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.contentDetailPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "phone02" }
        ],
        type: "find"
    });

    const emailString = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.contentDetailPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "emailString" }
        ],
        type: "find"
    });

    const email = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.contentDetailPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "email" }
        ],
        type: "find"
    });

    const youtube = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.contentDetailPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "youtube" }
        ],
        type: "find"
    });

    const linkedin = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.contentDetailPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "linkedin" }
        ],
        type: "find"
    });

    const instagram = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.contentDetailPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "instagram" }
        ],
        type: "find"
    });

    const getInTouchString = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.contentDetailPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "getInTouchString" }
        ],
        type: "find"
    });

    const sendUsMessageString = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.contentDetailPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "sendUsMessageString" }
        ],
        type: "find"
    });

    useEffect(
        () => {

            setTimeout(() => { props._hideLoader(); }, 100);

            return () => {
                props._showLoader();
                props._clean();
            }

        }, []
    )

    return (
        <>
            <ContentHeaderRow 
                title={languageVersion?.name} 
                description={languageVersion?.value} 
                resources={props.contentDetailPayload.resources} 
                resourceType={EResourceType.PARALLAX} 
            />
            
            <section className="contact-page">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6">
                            <div className="contact-page__left">
                                <div className="contact-page__img">
                                    <RMDRImage
                                        resources={props.contentDetailPayload.resources}
                                        resourceType={EResourceType.INNER_IMAGE}
                                        alt={languageVersion?.name}
                                        title={languageVersion?.name}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6">
                            <div className="contact-page__right">
                                <h3 className="contact-page__title">{letUsKnowAboutYourNextProject?.value}</h3>
                                <ul className="contact-page__contact-list list-unstyled">
                                    <li>
                                        <div className="icon">
                                            <span className="icon-location"></span>
                                        </div>
                                        <div className="content">
                                            <h3>{addressString?.value}</h3>
                                            <p>{address?.value}</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <span className="icon-call"></span>
                                        </div>
                                        <div className="content">
                                            <h3>{phoneNumberString?.value}</h3>
                                            <p>{phone01?.value}</p>
                                            <p>{phone02?.value}</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <span className="icon-email"></span>
                                        </div>
                                        <div className="content">
                                            <h3>{emailString?.value}</h3>
                                            <p>{email?.value}</p>
                                        </div>
                                    </li>
                                </ul>
                                <div className="contact-page__social">
                                    <Link to={youtube?.value||""}><FaYoutube /></Link>
                                    <Link to={linkedin?.value||""}><i className="icon-link-in"></i></Link>
                                    <Link to={instagram?.value||""}><i className="icon-instagram"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {
                googleMaps && googleMaps?.value ? (
                    <section className="google-map-one">
                        <iframe
                            title={languageVersion?.name||""}
                            src={googleMaps.value}
                            className="google-map__one"></iframe>

                    </section>
                ): null
            }

            <section className="contact-three">
                <div className="container">
                    <div className="row">
                        <div className="section-title text-center">
                            <div className="section-title__tagline-box">
                                <span className="section-title__tagline">{getInTouchString?.value}</span>
                            </div>
                            <h2 className="section-title__title">{sendUsMessageString?.value}</h2>
                        </div>

                        <ContactForm 
                            languageVersions={props.contentDetailPayload?.languageVersions}
                            className="contact-three__form" 
                        />
                    </div>
                </div>
            </section>
        </>
    )
}

const Component = React.memo(INNR003, ( prevProps:TINNRLayout<PropsFromRedux>, nextProps:TINNRLayout<PropsFromRedux> ) => {
    // return !(
    //     prevProps.contactUsPostPayload !== nextProps.contactUsPostPayload
    //     || prevProps.contactUsPostError !== nextProps.contactUsPostError
    // );
    return !(true);
});

export default connector(Component);

